<template>
    <v-container
        class="mx-0 px-0 py-0 my-0"
        fluid
        no-gutters
    >
        <v-btn
            v-scroll="onScroll"
            v-show="fab"
            fab
            dark
            fixed
            bottom
            right
            color="#1b2f5a"
            @click="toTop"
          >
            <v-icon large color="white">mdi-chevron-up</v-icon>
        </v-btn>
        <v-row no-gutters class="mb-10">
            <v-col cols=12 justify="center" align="center" class="mx-0 my-0 px-0 py-0">
                <v-img
                    height="auto"
                    width="100vw"
                    contain 
                    :src="require('@/assets/epixeiriseis ekptoseis.jpg')">
                </v-img>
            </v-col>
        </v-row>
        <v-row no-gutters :style="$vuetify.breakpoint.mobile ? 'padding-left: 18px; padding-right: 18px;' : 'padding-left: 180px; padding-right: 180px;'" v-if="$route.path==='/Partners'">
            <v-col 
                cols="12"
            >
                <v-card style="color: #1b2f5a;" :style="$vuetify.breakpoint.mobile ? 'max-height: 800px;' : 'max-height: 400px;'">
                    <v-row align="center" no-gutters>
                        <v-col cols="12" class="my-0 pt-5 pb-0 pl-5">
                           Φίλτρα
                           <v-icon>
                                mdi-tune-vertical
                           </v-icon>
                        </v-col>
                    </v-row>
                    <filters-component @fetchData="fetchFilteredData"/>
                </v-card>
            </v-col>
        </v-row>
        <v-row ref="partners" no-gutters :style="$vuetify.breakpoint.mobile ? 'padding-left: 18px; padding-right: 18px;' : 'padding-left: 180px; padding-right: 180px;'">
            <v-col 
                v-for="(entity, index) in data"
                :key="index"
                cols="12"
                md="6"
                sm="6"
                xs="12"
                lg="4"
                class="my-12 news"
            >
                <v-card v-if="$route.path=='/Teams'" style="color: #1b2f5a;" elevation="0" class="py-0 my-0 mx-5 px-3" :to="`/Team?id=${entity.id}`">
                    <v-row no-gutters justify="start" align="center" class="py-0 my-0" :style="$vuetify.breakpoint.mobile ? 'height: 200px;' : 'height: 150px;'">
                        <v-col cols="12" class="py-0 my-0">
                            <v-img
                                class="align-end card-img"
                                height="150px"
                                contain
                                :src="getImage(entity)"
                            />
                        </v-col>
                        <v-col cols="12" align="center" class="py-0 my-0 px-10">
                            <div class="two-line" :style="$vuetify.breakpoint.mobile ? 'font-size: 18px' : 'font-size: 18px'" style="word-break: break-word;">
                                {{entity.title}}
                            </div>
                        </v-col>
                    </v-row>
                </v-card>
                <!-- <v-hover v-slot="{ hover }"> -->
                <v-card v-else outlined elevation="0" class="card-bd py-0 my-0 mx-5 px-3" :to="`/Partner?id=${entity.id}`" style="color: #1b2f5a" :style="$vuetify.breakpoint.mobile ? 'font-size: 18px' : 'font-size: 18px'">
                    <v-row no-gutters justify="start" align="center" class="py-0 my-0" style="height: 100px;">
                        <v-col cols="4" class="py-0 my-0">
                            <v-img
                                class="align-end card-img"
                                height="100px"
                                contain
                                :src="getImage(entity)"
                            />
                        </v-col>
                        <v-col cols="8" class="py-0 my-0 pl-5">
                            <span style="color: #1b2f5a; text-align: justify; word-break: break-word;" class="two-line">
                                {{entity.title + ' - ' + entity.type}}
                            </span>
                        </v-col>
                    </v-row>
                    <v-row no-gutters justify="start" align="start" class="py-0 my-0">
                        <v-col cols="12" class="py-0 my-0">
                            <v-img :src="require('@/assets/divider.svg')"/>
                        </v-col>
                    </v-row>
                    <v-row no-gutters justify="start" align="start" class="py-0 my-0 pl-2 pb-2" style="font-size: 18px; color: #1b2f5a; text-align: justify; word-break: break-word;">
                        <v-col cols="12" class="py-0 two-line">
                            Έκπτωση: {{ entity.offers[0] ? entity.offers[0].description : '-' }}
                        </v-col>
                        <v-col cols="12" class="py-0 mt-2 two-line">
                            Διεύθυνση: {{ entity.address }}
                        </v-col>
                    </v-row>
                    <v-card-actions>
                        <v-btn
                            color="#ad282e"
                            text
                            :to="`/Partner?id=${entity.id}`"
                        >
                            Λεπτομέρειες
                        </v-btn>
                    </v-card-actions>
                    <!-- <v-expand-transition>
                        <div
                            v-if="hover"
                            class="d-flex transition-fast-in-fast-out darken-2 v-card--reveal white--text"
                            style="height: 100%;"
                        >
                            {{entity.title}}
                        </div>
                    </v-expand-transition> -->
                    <!-- <v-card-title class="mb-5 py-0 card-title" color="black">{{entity.title}}</v-card-title> -->
                </v-card>
                <!-- </v-hover> -->
            </v-col>
        </v-row>
        <v-row no-gutters class="mt-16">
            <v-col cols="12" align="center">
                <v-pagination
                    v-model="page"
                    :length="lastPage"
                    :total-visible="$vuetify.breakpoint.mobile ? 5 : 7"
                    @input="fetchData()"
                ></v-pagination>
            </v-col>
        </v-row>
        <paron-card-section/>
        <v-overlay :value="loading">
            <div class="text-center">
                <v-progress-circular
                    :size="70"
                    :width="7"
                    color="#1b2f5a"
                    indeterminate
                />
            </div>
        </v-overlay>
    </v-container>
</template>

<script>
import restApi from "@/rest-api";
import FiltersComponent from '@/components/FiltersComponent.vue'
import ParonCardSection from "../components/ParonCardSection.vue"

export default {
  components: { FiltersComponent, ParonCardSection },
  data() {
        return {
            data:[],
            partner: false,
            images:[
                {   id: "1",
                    src: require('@/assets/LOGOPARON 2023.svg'),
                }
            ],
            fab: false,
            page: 1,
            lastPage: 1,
            loading: false,
            filters: { }
        }
    },
    watch:{
        $route(to, from) {
            if(to !== from ) {
                this.data = []
                this.page = 1
                this.lastPage = 1
                if(to.name === 'Teams') {
                    this.fetchData()
                }
            }
        }
    },
    computed: {
    },
    mounted() {
    },
    created() {
        if(this.$route.path.includes('Teams')) {
            this.fetchData()
        }
    },
    methods: {
        fetchFilteredData(filters) {
            this.data = []
            this.page = 1
            this.filters = filters
            this.fetchData()
        },
        fetchData() {
            this.loading = true
            this.partner = true;
            this.fetchPartners(this.filters);
            this.toPartners()
        },
        fetchPartners(filters) {
            var search = `/partner/filtered?page=${this.page}&per_page=12`;
            filters.b2b = true
            restApi
            .post(search, filters)
            .then(response => {
                this.data = response.data
                this.lastPage = response.last_page
                this.loading = false
                var centerCoordinates = this.filters.center.split(',')
                this.data.forEach(element => {
                    var coordinates = element.coordinates.split(',')
                    element.distance = this.haversineDistanceBetweenPoints(parseFloat(centerCoordinates[0]), parseFloat(centerCoordinates[1]), parseFloat(coordinates[0]), parseFloat(coordinates[1]))
                })
                this.data.sort(
                    (a,b) => a.distance - b.distance
                )
            })
            .catch((error) => {
                console.log(error);
                this.loading = false
            });
        },
        haversineDistanceBetweenPoints(lat1, lon1, lat2, lon2) {
            const R = 6371e3
            const p1 = lat1 * Math.PI/180
            const p2 = lat2 * Math.PI/180
            const deltaLon = lon2 - lon1
            const deltaLambda = (deltaLon * Math.PI) / 180
            const d = Math.acos(
                Math.sin(p1) * Math.sin(p2) + Math.cos(p1) * Math.cos(p2) * Math.cos(deltaLambda),
            ) * R
            return d
        },
        getImage(entity) {
            var image = entity.image;
            if(image) {
                return `https://dev.paron-card.gr/uploads/images/${image.imageName}`
            } else {
                return require('@/assets/LOGOPARON 2023.svg')
            }
        },
        goToPartner(id) {
            this.$router.push({path: 'Partner', query: { id: id }});
        },
        goToLink(id) { 
            if(this.partner) {
                this.goToPartner(id);
            } else {
                this.goToTeam(id);
            }

        },
        onScroll (e) {
            if (typeof window === 'undefined') return
            const top = window.pageYOffset ||   e.target.scrollTop || 0
            this.fab = top > 20
        },
        toPartners () {
            this.$vuetify.goTo(this.$refs.partners)
        },
        toTop() {
            this.$vuetify.goTo(0)
        }
    }
}
</script>

<style lang="scss" scoped>
    .two-line {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
                line-clamp: 2; 
        -webkit-box-orient: vertical;
    }

    @media only screen and (min-width: 600px){
        .projects-nav {
            padding:5% 0% 5% 0%;
            width:80%;
        }

    }
    @media only screen and (max-width: 600px){
        .projects-nav {
            padding:15% 0% 15% 0%;
            width:100%;
        }
    }
    .card-bd{
        height: 270px; 
        border: 2px solid #1b2f5a !important;
    }

    .v-card--reveal {
        align-items: center;
        bottom: 0;
        justify-content: center;
        opacity: 0.9;
        position: absolute;
        width: 100%;
        background-color: #1b2f5a;
        font-size: 4vh;
        padding-left: 20px;
    }

    .card-actions {
      position: absolute;
      bottom: 0;
    }

    .card-title {
        font-size: 1.3rem;
        color: #ad282e;
        font-weight: 500;
    }

</style>